export default "__VITE_ASSET__2uIXPxwM__"